import { SyntheticEvent, useEffect, useState } from 'react';
import { Autocomplete as MuiAutocomplete, TextField } from '@mui/material';
import { CoreTypography } from '@youscience/core';
import { isEmpty } from 'lodash-es';

import { STATES_OF_USA } from '@utils/states';
import { AutocompleteOption } from '@interfaces';
import useSchoolSelectionStore, { STEPS } from '@store/SchoolSelectionStore';
import { renderNoOptionsText } from '@components/Form/Autocomplete/Autocomplete';

import { sxStyles, StyledStep1Wrap } from './SelectionStep1.styles';

export const SelectionStep1 = () => {
  const { state, schoolListOptions, schoolPreviewInfo } = useSchoolSelectionStore((state) => state.schoolSelectionData);
  const getSchoolListByState = useSchoolSelectionStore((state) => state.getSchoolListByState);
  const getSchoolInfo = useSchoolSelectionStore((state) => state.getSchoolInfo);
  const setSchoolSelectionData = useSchoolSelectionStore((state) => state.setSchoolSelectionData);

  const selectedSchool = isEmpty(schoolPreviewInfo)
    ? null
    : {
        label: `${schoolPreviewInfo?.name} (${schoolPreviewInfo?.zip}, ${schoolPreviewInfo?.city})`,
        value: schoolPreviewInfo?.id.toString(),
      };

  const [school, setEnrolledSchool] = useState(selectedSchool);

  const handleSelectState = (event: SyntheticEvent, state: AutocompleteOption | null) => {
    void setSchoolSelectionData({ state });

    setEnrolledSchool(null);
  };

  const handleSelectEnrolledSchool = (event: SyntheticEvent, school: AutocompleteOption | null) => {
    if (!school) return;

    const currentSchool = {
      label: school?.label.split('(')[0].trim(),
      value: school?.value,
    };

    void setSchoolSelectionData({ activeStep: STEPS.step2, school: currentSchool as AutocompleteOption });
    void getSchoolInfo();
  };

  useEffect(() => {
    void getSchoolListByState();
  }, [state]);

  return (
    <StyledStep1Wrap>
      <CoreTypography data-testid="step1Subtitle" sx={sxStyles.subtitle} variant="body2">
        That’s a huge step in your life. Find your school by selecting the state then typing the name of your school.
      </CoreTypography>

      <MuiAutocomplete
        data-testid="enrolledStatesAutocomplete"
        size="small"
        options={STATES_OF_USA}
        value={state}
        onChange={handleSelectState}
        renderInput={(params) => <TextField {...params} label="State" />}
        clearIcon={null}
        noOptionsText={renderNoOptionsText()}
      />

      {state && schoolListOptions && schoolListOptions.length > 0 && (
        <MuiAutocomplete
          data-testid="schoolSearchAutocomplete"
          sx={sxStyles.schoolSearch}
          size="small"
          value={school}
          options={schoolListOptions}
          onChange={handleSelectEnrolledSchool}
          renderInput={(params) => <TextField {...params} label="Educational Institution Name" />}
          clearIcon={null}
          noOptionsText={renderNoOptionsText()}
          renderOption={(props, option) => (
            <li {...props} key={option.value}>
              {option.label}
            </li>
          )}
        />
      )}
    </StyledStep1Wrap>
  );
};
